import CapitalizationUtil from "../../utils/CapitalizationUtil.ts";
import { GenericResponseType } from "../../types/response.ts";
import { COMMON_API_URL } from "../../constants/urls";

const postData = async (
  jwt: string,
  callfunc: string,
  additionalParams?: object
): Promise<any> => {
  const response = await fetch(`${COMMON_API_URL}/${callfunc}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwt}`,
    },
    body: JSON.stringify({ ...additionalParams }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data: GenericResponseType =
    CapitalizationUtil.convertTopLevelKeysToCamelCase(await response.json());

  if (data.error) {
    throw new Error(data.error);
  }

  return data.result.vehicleData ? data.result.vehicleData : data.result;
};

const getVehicleTypes = async (
  jwt: string
): Promise<{ [key: string]: string }> => {
  return postData(jwt, "getCar_type");
};

const getVehicleBrands = async (
  jwt: string
): Promise<{ [key: string]: string }> => {
  return postData(jwt, "getVehiclebrand");
};

const getVehicleUsages = async (
  jwt: string
): Promise<{ [key: string]: string }> => {
  return postData(jwt, "getCar_usage");
};

const getVehicleById = async (jwt: string, carId: string): Promise<object> => {
  return await postData(jwt, "getCarById", { CAR_ID: carId });
};

const getVehicle = async (
  registrationNumber: string,
  certificateNumber: string,
  jwt: string
): Promise<object> => {
  return postData(jwt, "getCar", {
    RegNo: registrationNumber || "",
    Talon: certificateNumber || "",
  });
};

const saveVehicle = async (jwt: string, vehicleData: object): Promise<any> => {
  return postData(jwt, "car_write", { vehicleData });
};

const getVehiclePolicies = async (
  registrationNumber = "",
  certificateNumber = "",
  jwt: string
): Promise<object> => {
  return postData(jwt, "getCar_Policies", {
    RegNo: registrationNumber,
    Talon: certificateNumber,
  });
};

const VehicleService = {
  getVehicleTypes,
  getVehicleBrands,
  getVehicleUsages,
  getVehicleById,
  getVehicle,
  getVehiclePolicies,
  saveVehicle,
};

export default VehicleService;
